import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ColorPickerPopover from './ColorPickerPopover.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConditionalColorPicker',
  props: {
  id: { type: String, default: '' },
  label: { type: String, default: '' },
  required: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  initialColor: { type: String, default: 'rgba(0, 0, 0, 1)' }
},
  emits: ["colorChange"],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ColorPickerPopover, {
    id: __props.id,
    label: __props.label,
    required: __props.required,
    disabled: __props.disabled,
    initialColor: __props.initialColor,
    onColorChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('colorChange', $event)))
  }, null, 8, ["id", "label", "required", "disabled", "initialColor"]))
}
}

})